module.exports = function abortCb(cb, abort, onAbort) {
  cb(abort)
  onAbort && onAbort(abort === true ? null: abort)
  return
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/pull-stream/util/abort-cb.js
// module id = 327
// module chunks = 0